import { ClerkProvider } from '@clerk/react'
import { Sentry } from './monitoring'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { App, E2EApp } from './app'
import { env } from './env'
import './styles.css'

const root = createRoot(document.getElementById('root')!, {
  onUncaughtError: Sentry.reactErrorHandler(),
  onCaughtError: Sentry.reactErrorHandler(),
})

if (env.E2E_TOKEN) {
  // Playwright (로컬): Clerk 없이 바로 셸. API 가 로컬에서만 이 토큰을 인정한다
  root.render(
    <StrictMode>
      <BrowserRouter>
        <E2EApp />
      </BrowserRouter>
    </StrictMode>,
  )
} else {
  const key = env.CLERK_PUBLISHABLE_KEY
  if (!key) throw new Error('VITE_CLERK_PUBLISHABLE_KEY is not set')
  root.render(
    <StrictMode>
      <ClerkProvider publishableKey={key}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ClerkProvider>
    </StrictMode>,
  )
}
